<template>
  <div>
    <div v-if="!hasRightActions || noDialog">{{ titleName }}</div>
    <v-edit-dialog :return-value="item[property]" large lazy v-else @save="saveInline">
      <div>{{ titleName }}</div>
      <core-error v-if="item.errors" :property="property" :errors="item.errors[property]" />
      <template v-slot:input>
        <v-text-field
          v-bind:value="item[property]"
          v-on:change="newObject = $event"
          :rules="textRules"
          :label="labelName"
          counter
          autofocus
          :readonly="readonly"
          @update:error="showError"
        />
      </template>
    </v-edit-dialog>
  </div>
</template>

<script>
/* eslint max-len:0 */
import { mapGetters } from 'vuex';
import DialogBaseMixins from '../../mixins/dialog-base';
import ProfileMixins from '../../mixins/profile-base';

export default {
  mixins: [DialogBaseMixins, ProfileMixins],
  props: {
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('form/rules', { textRules: 'text' }),
    itemsKey: () => undefined,
  },
};
</script>

<!-- Using the BEM convention -->
<style></style>
